import http from "./../../../../../api/http";


export const getSearch = (query) => http().get(`/api/search?query=${query}`);

export default { getSearch }
